import { render, staticRenderFns } from "./AlertChip.vue?vue&type=template&id=2a124d62"
import script from "./AlertChip.vue?vue&type=script&lang=js"
export * from "./AlertChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports